import { useSearchParams } from 'next/navigation';
import { useEffect, useMemo, useState } from 'react';

import { getListMarketplace } from '@/services';
import type { NftMarket } from '@/types';

export const PAGE_SIZE = 60;

const useMarketplace = () => {
  const [totalPage, setTotalPage] = useState(0);
  const [data, setData] = useState<NftMarket[]>([]);
  const [loading, setLoading] = useState(false);

  const searchParam = useSearchParams();
  const page = searchParam.get('page') ?? 1;
  const tagIds = searchParam.get('tagIds') ?? null;
  const modelIds = searchParam.get('modelIds') ?? null;
  const assetCategory = searchParam.get('assetCategory') ?? '';
  const priceFrom = searchParam.get('priceFrom');
  const priceTo = searchParam.get('priceTo');
  const prompt = searchParam.get('prompt') || (assetCategory ? false : null);
  const createdAt = searchParam.get('createdAt') ?? 'DESC';
  const isPlus = searchParam.get('isPlus') ?? null;
  const name = searchParam.get('name') ?? '';

  const inputParams = useMemo(
    () => ({
      offset: page ? (Number(page) - 1) * PAGE_SIZE : 0,
      size: PAGE_SIZE,
      sort: `{"createdAt":"${createdAt}"}`,
      filter: `{"name":"${name}","tagIds":${tagIds},"modelIds":${modelIds},"assetCategory":"${assetCategory}","priceFrom":${priceFrom},"priceTo":${priceTo},"prompt":${prompt},"denom":"AIRI","isPlus":${isPlus}}`,
    }),
    [page, createdAt, name, tagIds, modelIds, assetCategory, priceFrom, priceTo, prompt, isPlus],
  );

  const handleGetListMarketplace = async () => {
    setLoading(true);

    const res = await getListMarketplace(inputParams);

    setTotalPage(res?.data?.total || 0);
    setData(res?.data?.items || []);
    setLoading(false);
  };

  useEffect(() => {
    handleGetListMarketplace();
  }, [inputParams]);

  return {
    list: data,
    loading,
    setData,
    totalPage,
  };
};

export default useMarketplace;
